import LazyLoad from "vanilla-lazyload";

export function initLazyLoad() {
    const lazyLoadInstance = new LazyLoad({});
    lazyLoadInstance.update();
}
